export default {
    pokemonListHeadline: "Deine Pokémon",

    // info panel
    info: "Info",
    team: "Team",
    stats: "Stats",
    moves: "Moves",
    movesNotFound: "Die Attacken konnten nicht gefunden werden",
    name: "Name",
    hp: "Hp",
    attack: "Angriff",
    specialAttack: "Spezial Angr.",
    defense: "Verteidigung",
    specialDefense: "Spezial-Vert.",
    speed: "Initiative",
    total: "Total",
    progress: "Fortschritt",
    weight: "Gewicht",
    generation: "Generation",
    base_stats: "Basiswerte",

    // stat values
    horrible: "Furchtbar",
    bad: "Schlecht",
    avg: "Mittelmäßig",
    good: "Gut",
    fantastic: "Fantastisch",
    perfect: "Perfekt",

    // additional infos
    caughtBy: "Gefangen von",
    originalChannel: "Herkunft",
    caughtAtFormat: (year, month, day) => `${day}.${month}.${year}`,

    // selling
    sell: (amount) => `Verkaufen $${amount}`,
    sellConfirmMessage: (name, lvl) => `Bist du sicher, dass du dein <span class="font-weight-bold">${name} LVL. ${lvl}</span> verkaufen möchtest?`,
    trade: 'Tauschen',
    wondertrade: 'Wundertausch',
    tradeConfirmMessage: (name, lvl) => `Bist du sicher, dass du dein <span class="font-weight-bold">${name} LVL. ${lvl}</span> tauschen möchtest?`,
    sellSuccess: "Du hast dein Pokémon in Obhut des Händlers gegeben",
    sellLast: "Du kannst dein letztes Pokémon nicht verkaufen",
    sellNotExists: "Das Pokémon existiert nicht mehr",
    sellNotYourPokemon: "Das Pokémon gehört dir nicht mehr",
    sellPriceChanged: "Der Verkaufspreis deines Pokemons hat sich geändert! Bitte aktualisiere die Extension!",

    tradeCooldown: (time) => `Cooldown: ${time}`,
    tradeCooldownIsActive: "You already wondertraded in the past 3 hours",

    // sort filter
    changeSort: "Sortierung ändern",
    sortByID: "ID",
    sortByName: "Name",
    sortByLevel: "Level",
    sortByHP: "KP",
    sortByPrice: "Preis",
    sortByShiny: "Shiny",
    sortByBaseStat: "Base stats",
    sortByAvgIV: "IV",
    sortByRecent: "Kürzlich",

    // error messages
    PokemonTeamFull: "Das Team ist voll",
    PokemonNotInTeam: "Das Pokemon ist nicht in deinem Team",
    PokemonAlreadyInTeam: "Pokemon ist schon im Team",
    PokemonNotOwnedAnymore: "Du bestzt das Pokemon nicht mehr",

    PokemonNicknameTooLong: "Der Spitzname ist zu lang",
    PokemonTeamNameTooLong: "Der Name deines Teams ist zu lang",

    caughtOn: "Caught on"
};